import React, { useState } from "react";
import { Container, Grid, Typography, TextField, Button, Box, Link } from '@mui/material';
import { LocationOn, Phone, MailOutline } from '@mui/icons-material';
import Layout from "./../components/Layout/Layout";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      errors.email = "Valid email is required";
    if (!formData.phone || !/^\d{10}$/.test(formData.phone))
      errors.phone = "Valid 10-digit phone number is required";
    if (!formData.message) errors.message = "Message is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        await axios.post("https://api.finnkoda.com/send", formData);
        toast.success("Message sent successfully!", { position: "top-right", autoClose: 1000 });
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
        // alert("Message sent successfully!");
        // window.location.reload(); 
      } catch (error) {
        console.error("Error sending message", error);
        toast.error("Failed to send message", { position: "top-right" });
        // alert("Failed to send message");
      }
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <Layout>
      <HelmetProvider>
        <Helmet>
          <title>Contact Us | Financial Guidance & Support</title>
          <meta name="description" content="Contact us for expert financial guidance. Get the latest financial information to make informed decisions, manage assets, and plan for a secure future." />
          <meta name="keywords" content="contact us, financial information, informed decisions, manage assets, secure future, financial planning, investment guidance, money management, financial advice, personal finance" />
          <link rel="canonical" href="https://finnkoda.com/contact" />
          <link rel="alternate" media="only screen and (max-width: 640px)" href="https://finnkoda.com/contact" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Finnkoda | Contact us" />
          <meta property="og:url" content="https://finnkoda.com/contact" />
          <meta property="og:image" content="%PUBLIC_URL%/logo.png" />
          <meta property="og:description" content="Get in touch with us for expert financial advice. We provide guidance on managing assets, making informed decisions, and securing your financial future. Contact us today!" />

          {/* Twitter */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Finnkoda | Contact us" />
          <meta name="twitter:site" content="@Finnkoda" />
          <meta name="twitter:description" content="Need financial assistance? Contact us for expert advice on managing assets, financial planning, and making informed decisions for a secure future." />
          <meta name="twitter:image" content="%PUBLIC_URL%/logo.png" />
          <meta name="twitter:image:alt" content="Finnkoda" />


        </Helmet>
      </HelmetProvider>
      <Box sx={{ padding: '40px 0' }}>
        <Container>
          {/* <Box sx={{ textAlign: "center", maxWidth: 800, mx: "auto", mb: 5 }}>
            <Typography variant="h4"> Send Your Message</Typography>
            <Typography variant="body1" sx={{ padding: '0px 150px 0px 150px' }}>Get in touch with our expert financial consultants to receive personalized advice and guidance, helping you make informed decisions and secure a prosperous financial future.</Typography>
          </Box> */}

          <Grid container spacing={4}>
            {/* Left Section */}
            <Grid item xs={12} md={5}>
              <Box sx={{
                backgroundColor: 'background.paper',
                padding: 3,
                boxShadow: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
                borderRadius: 2,  // Rounded corners
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <LocationOn sx={{ fontSize: 40, color: '#1a7d3b', marginRight: 2 }} />
                  <Box>
                    <Link
                      href="https://www.google.com/maps/place/FasturaTechnologies/@9.924109,78.1445669,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae10e042e1b15f:0xd20059cfd0695fe3!8m2!3d9.9241037!4d78.1471418!16s%2Fg%2F11cn3h940j?entry=ttu&g_ep=EgoyMDI1MDEwMi4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      sx={{
                        color: '#000000DE',
                        textDecoration: 'none',
                      }}
                    >
                      <Typography variant="h6">Address</Typography>
                      <Typography>#311, 1st East Main Road, Sathamangalam, Anna Nagar, Madurai, Tamil Nadu 625020.</Typography>
                    </Link>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <Phone sx={{ fontSize: 40, color: '#1a7d3b', marginRight: 2 }} />
                  <Box>
                    <Link
                      href="tel:+919943430035"
                      sx={{
                        color: '#000000DE',
                        textDecoration: 'none',
                      }}
                    >
                      <Typography variant="h6">Mobile</Typography>
                      <Typography>+91 9943430035</Typography>
                    </Link>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                  <MailOutline sx={{ fontSize: 40, color: '#1a7d3b', marginRight: 2 }} />
                  <Box>
                    <Link
                      href="mailto:contact@finnkoda.com"
                      sx={{
                        color: '#000000DE',
                        textDecoration: 'none',
                      }}
                    >
                      <Typography variant="h6">Mail Us</Typography>
                      <Typography>contact@finnkoda.com</Typography>
                    </Link>
                  </Box>
                </Box>

                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.118310994145!2d78.1471418!3d9.924103700000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae10e042e1b15f%3A0xd20059cfd0695fe3!2sFasturaTechnologies!5e0!3m2!1sen!2sin!4v1736317356655!5m2!1sen!2sin"
                  width="100%"
                  height="270"
                  style={{ border: 0, borderRadius: 2 }}
                  allowFullScreen
                  loading="lazy"
                  title="Map showing Fastura Technologies location"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Box sx={{
                backgroundColor: 'background.paper',
                padding: 3,
                boxShadow: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
                borderRadius: 2,  // Rounded corners
              }}>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Your Name"
                        variant="outlined"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        error={!!errors.name}
                        helperText={errors.name}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Your Email"
                        variant="outlined"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        error={!!errors.email}
                        helperText={errors.email}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        error={!!errors.phone}
                        helperText={errors.phone}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Subject"
                        variant="outlined"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Message"
                        variant="outlined"
                        name="message"
                        multiline
                        rows={6}
                        value={formData.message}
                        onChange={handleChange}
                        error={!!errors.message}
                        helperText={errors.message}
                      />
                    </Grid>
                    <Grid item xs={12} textAlign="center">
                      <Button type="submit" variant="contained" sx={{
                        backgroundColor: '#1a7d3b',
                        '&:hover': {
                          backgroundColor: '#156e29',
                        },
                        px: 5,
                        py: 1.5,
                        textTransform: "none",
                        fontSize: "1rem"
                      }}>
                        Send Message
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>

          </Grid>
        </Container>
      </Box>
    </Layout>
  );
};

export default Contact;
